<template>
  <div v-loading="loading" class="HistoryDiv">
    <table>
      <thead>
        <tr>
          <th>历史数据（已过滤上面最新数据）</th>
        </tr>
      </thead>
      <tbody id="topSearch">
        <tr v-for="(item, index) in getHistoryData" :key="index">
          <td
            :class="[item.Note ? '' : 'timebox']"
            :title="item.Title"
            @click="SearchWords(item.Title, item.ResourceGuid)"
          >
            <span>{{ escape2Html(item.Title) }}</span>
          </td>
          <td
            :class="[item.Note ? '' : 'right']"
            :title="
              item.BDTime ? item.BDTime.replace('T00:00:00', '') : item.BDTime
            "
          >
            {{
              item.BDTime ? item.BDTime.replace("T00:00:00", "") : item.BDTime
            }}
          </td>
          <td v-if="item.Note" :title="item.Note">
            {{ item.Note }}
          </td>
        </tr>
      </tbody>
    </table>
    <el-pagination
      ref="pagination"
      background
      layout="prev, pager, next, jumper"
      :total="rowCount"
      :current-page="pageable.pageIndex"
      :page-size="pageable.pageSize"
      :pager-count="5"
      @current-change="goPage"
      hide-on-single-page
    ></el-pagination>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Pageable } from "../../assets/script/model/";
export default {
  name: "HotHistoryList",
  props: ["getHistoryGuid", "txtType"],
  data() {
    return {
      tableHeight: 700,
      loading: false,
      rowCount: 0,
      getHistoryData: []
    };
  },
  computed: {
    pageable: {
      get() {
        return this.$store.state.hotList.Pageable;
      },
      set(val) {
        this.$store.state.hotList.Pageable = val;
      }
    }
  },
  watch: {
    getHistoryGuid: {
      handler(val) {
        if (val !== "") {
          this.pageable = new Pageable(1, 30);
          this.getHistoryList(val);
          this.$emit("pageIndexNum", this.pageable.pageIndex);
        }
      }
    }
  },
  methods: {
    ...mapActions("hotList", ["AHotRankHistoryList"]),
    SearchWords(keyword, guid) {
      if (this.txtType === "word") {
        this.$router.push("/material/article/" + keyword);
      } else {
        this.$router.push("/article/hotBd/" + guid);
      }
    },
    async getHistoryList(guid) {
      let data = {
        rankingListGuid: guid,
        txtType: "",
        pageIndex: this.pageable.pageIndex
      };
      let result = await this.AHotRankHistoryList(data);
      if (result.ErrorCode === 0) {
        this.getHistoryData = result.Data.History;
        this.rowCount = result.Data.RowCount;
      }
    },
    goPage(pageIndex) {
      this.pageable.pageIndex = pageIndex;
      this.$emit("pageIndexNum", pageIndex);
      this.getHistoryList(this.getHistoryGuid);
      this.scrollTop("bodyMain", "class");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/mixin";
@import "../../assets/style/color";
.pageIndex();
.timebox {
  width: 70% !important;
}
.HistoryDiv {
  padding-top: 20px;
  width: 460px;
  color: #666;
  font-size: 12px;
  height: 100%;
  .bodyMain {
    height: 700px;
    overflow-y: auto;
    overscroll-behavior-y: contain;
  }

  table tbody {
    display: block;
  }

  table thead,
  tbody tr,
  tfoot tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  table thead {
    width: calc(100% - 1em);
  }

  table {
    width: 100%;
    text-align: left;

    td,
    th {
      border: 0;
      display: inline-block;
      .ellipsis();

      &:nth-child(1) {
        width: 60%;
        cursor: pointer;
      }
      &:nth-child(2) {
        width: 25%;
        cursor: pointer;
      }
      &:nth-child(3) {
        width: 15%;
      }

      span {
        padding-right: 5px;
      }
    }

    tbody {
      tr {
        line-height: 30px;

        &:hover {
          background-color: @body-background-color;
        }

        border-bottom: 1px solid @borderbottom;
      }
    }

    tbody:before {
      content: "-";
      display: block;
      line-height: 1px;
      color: transparent;
    }

    th {
      font-weight: 500;
      color: #909399;
    }
  }
}
</style>
